<template>
  <b-table id="punch-card-campaign-list" v-dragscroll :items="items" :fields="tableFields" responsive show-empty
    :empty-text="emptyText" :busy.sync="loading"
    class="base-table no-vertical-borders rounded-0 border-0 shadow-none mt-4">
    <template slot="HEAD_action">
      <ListViewToggle />
    </template>
    <template slot="name" slot-scope="{ item }">
      <div class="d-inline-flex align-items-center">
        <span
          :class="['img-wrapper mr-2 d-inline-flex align-items-center justify-content-center overflow-hidden flex-shrink-0', { 'bg-light': !item.image }]">
          <img :src="item.image" :alt="item.name" class="img-fluid" v-if="item.image">
        </span>
        <span class="font-weight-bold">{{ item.name }}</span>
      </div>
    </template>
    <template slot="status" slot-scope="data">
      <div class="d-inline-flex align-items-center">
        <div :class="['status-dot mr-2', `-${data.value}`]"></div>
        <span :class="['text-capitalize punch-card-status', `-${data.value}`]">{{ data.value }}</span>
      </div>
    </template>
    <template slot="action" slot-scope="{ item }">
      <ActionButtons :uuid="item.uuid" />
    </template>
  </b-table>
</template>

<script>
import { mapState } from "vuex";
import { dragscroll } from "vue-dragscroll";
import { thousandsSeparator, durationDisplay } from "./punch.card.utilities";
import ListViewToggle from "./PunchCardListViewToggle.vue";
import ActionButtons from "./PunchCardActionButtons.vue";

export default {
  components: { ListViewToggle, ActionButtons },
  computed: {
    ...mapState("punchCard", {
      items: (state) => state.campaigns,
      loading: (state) => state.loading
    }),
    emptyText: {
      get() {
        if (this.loading) return "Loading...";

        return "No records found."
      },
      set(text) {
        return text;
      }
    }
  },
  directives: { dragscroll },
  data() {
    return {
      tableFields: [
        { key: "name", label: "Campaign Name", thClass: "text-nowrap" },
        {
          key: "participants",
          label: "Members",
          formatter: (value) => {
            return this.thousandsSeparator(value);
          }
        },
        {
          key: "duration",
          formatter: (_, __, item) => {
            const { date_start, date_end } = item;

            if (date_start && date_end) return this.durationDisplay(date_start, date_end, "dateOnly");

            return "Lifetime";
          },
          tdClass: "text-nowrap"
        },
        { key: "status", formatter: (value) => value.toLowerCase() },
        { key: "action", label: "", thClass: "text-right", tdClass: "text-right text-nowrap" }
      ],
      thousandsSeparator,
      durationDisplay
    }
  },
  watch: {
    items() {
      const table = document.getElementsByClassName("base-table")[0];

      if (table && table.scrollLeft > 0) {
        table.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-wrapper {
  width: 40px;
  height: 32px;

  &>img {
    object-fit: fill;
  }
}
</style>

<style lang="scss">
#punch-card-campaign-list {
  @import "~@/assets/scss/punch-card/_status.scss";
}
</style>
